export default "__VITE_ASSET__BkaE9PaL__"